'use strict';

var chunkWVST6R4U_js = require('./chunk-WVST6R4U.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var e = require('react');
var r = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var e__default = /*#__PURE__*/_interopDefault(e);
var r__default = /*#__PURE__*/_interopDefault(r);

var f=r__default.default.ul`
  list-style: none;
  list-style-type: none;
  width: 100%;
  overflow: auto;
  height: 100%;
  padding: 0;
  margin: 0;
  cursor: pointer;
`,x=r__default.default.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${({$padding:o})=>o};
  width: 100%;
  margin-bottom: ${({$margin:o})=>o};
  text-overflow: hidden;
  word-wrap: break-word;
  gap: ${({$gap:o})=>o};

  ${({$divider:o,$borderColor:i})=>o&&`border-bottom: 1px solid ${i}`};

  &:last-child {
    margin-bottom: 0;
    border: none;
  }
`,b=r__default.default.span`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
`,$=r__default.default.a`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
  text-decoration: none;
`,C=({items:o,onClick:i=n=>{},prefixElement:d=null,suffixElement:s=null,divider:g=!0,renderPrefix:a})=>{let{tokens:n}=chunkHUKGHOBJ_js.b(),c=e.useCallback(t=>{i(t);},[]);return e__default.default.createElement(f,null,o.map((t,y)=>{let m=t.isHyperLink&&t.url?$:b;return e__default.default.createElement(x,{key:y,onClick:()=>c(t),$divider:g,$borderColor:n.border_default_border_disabled,$gap:n.spacing_8,$padding:n.spacing_12,$margin:n.spacing_20},typeof a=="function"?a(t):e__default.default.isValidElement(d)&&d,e__default.default.createElement(m,{...t.isHyperLink&&t.url&&{href:t.url}},e__default.default.createElement(chunkWVST6R4U_js.a,{color:n.text_default_text_primary,fontWeight:"medium",size:"250"},t.label),t.text&&e__default.default.createElement(chunkWVST6R4U_js.a,{size:"200",color:n.text_default_text_secondary,fontWeight:"regular"},t.text)),e__default.default.isValidElement(s)&&s)}))};

exports.a = C;
